import React, { useState, useEffect } from 'react';
import { useContent } from '../../contexts/ContentContext';
import './FeaturedProgramsAdmin.css'; // Reuse the same styles

const ExpertsTeamAdmin = ({ contentPath }) => {
  const { getContent, updateContent } = useContent();
  const [sectionData, setSectionData] = useState(null);

  useEffect(() => {
    const data = getContent(contentPath);
    setSectionData(data);
  }, [contentPath, getContent]);

  const handleSectionUpdate = (field, value) => {
    updateContent(`${contentPath}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleTrainerUpdate = (index, field, value) => {
    updateContent(`${contentPath}.trainers.${index}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleSpecialtyUpdate = (trainerIndex, specialtyIndex, value) => {
    updateContent(`${contentPath}.trainers.${trainerIndex}.specialties.${specialtyIndex}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleAddSpecialty = (trainerIndex) => {
    const trainer = sectionData.trainers[trainerIndex];
    const specialties = trainer.specialties || [];
    updateContent(`${contentPath}.trainers.${trainerIndex}.specialties`, [...specialties, '']);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteSpecialty = (trainerIndex, specialtyIndex) => {
    const trainer = sectionData.trainers[trainerIndex];
    const specialties = trainer.specialties.filter((_, i) => i !== specialtyIndex);
    updateContent(`${contentPath}.trainers.${trainerIndex}.specialties`, specialties);
    setSectionData(getContent(contentPath));
  };

  const handleFormationUpdate = (trainerIndex, formationIndex, value) => {
    updateContent(`${contentPath}.trainers.${trainerIndex}.formations.${formationIndex}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleAddFormation = (trainerIndex) => {
    const trainer = sectionData.trainers[trainerIndex];
    const formations = trainer.formations || [];
    updateContent(`${contentPath}.trainers.${trainerIndex}.formations`, [...formations, '']);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteFormation = (trainerIndex, formationIndex) => {
    const trainer = sectionData.trainers[trainerIndex];
    const formations = trainer.formations.filter((_, i) => i !== formationIndex);
    updateContent(`${contentPath}.trainers.${trainerIndex}.formations`, formations);
    setSectionData(getContent(contentPath));
  };

  const handleAddTrainer = () => {
    const trainers = sectionData?.trainers || [];
    const newTrainer = {
      id: '',
      name: '',
      title: '',
      photo: '',
      specialties: [],
      cv: '',
      formations: [],
      country: '',
      flagIcon: ''
    };

    updateContent(`${contentPath}.trainers`, [...trainers, newTrainer]);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteTrainer = (index) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce formateur ?')) {
      const trainers = sectionData?.trainers || [];
      const updatedTrainers = trainers.filter((_, i) => i !== index);
      updateContent(`${contentPath}.trainers`, updatedTrainers);
      setSectionData(getContent(contentPath));
    }
  };

  if (!sectionData) {
    return (
      <div className="programs-admin-loading">
        <i className="fas fa-spinner fa-spin"></i>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="programs-admin">
      {/* Section Header Settings */}
      <div className="admin-section-header">
        <div className="section-info">
          <h2>
            <i className="fas fa-user-md"></i>
            Équipe de Formateurs Experts
          </h2>
          <p>Gérez votre équipe de formateurs qualifiés qui transforment votre pratique dentaire</p>
        </div>
        <button 
          className="btn-add-program"
          onClick={handleAddTrainer}
        >
          <i className="fas fa-plus"></i>
          Ajouter un formateur
        </button>
      </div>

      {/* Section Title & Subtitle */}
      <div className="section-settings">
        <div className="setting-group">
          <label>Titre de la section</label>
          <input
            type="text"
            value={sectionData.title || ''}
            onChange={(e) => handleSectionUpdate('title', e.target.value)}
            placeholder="Nos Formateurs Experts"
          />
        </div>
        <div className="setting-group">
          <label>Sous-titre</label>
          <textarea
            value={sectionData.subtitle || ''}
            onChange={(e) => handleSectionUpdate('subtitle', e.target.value)}
            placeholder="Rencontrez notre équipe de formateurs qualifiés..."
            rows={2}
          />
        </div>
      </div>

      {/* Trainers List */}
      <div className="programs-list-admin">
        {(sectionData.trainers || []).map((trainer, index) => (
          <div key={index} className="program-item-admin">
            <div className="program-header">
              <div className="program-title-area">
                <h3>
                  <i className="fas fa-user-md"></i>
                  {trainer.name || `Formateur ${index + 1}`}
                </h3>
                {trainer.title && (
                  <span className="program-badge">
                    {trainer.title}
                  </span>
                )}
              </div>
              <div className="program-actions">
                <button
                  className="btn-delete"
                  onClick={() => handleDeleteTrainer(index)}
                  title="Supprimer ce formateur"
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>

            {/* Clean Horizontal Form Fields */}
            <div className="form-grid">
              <div className="form-group">
                <label>Id</label>
                <input
                  type="text"
                  value={trainer.id || ''}
                  onChange={(e) => handleTrainerUpdate(index, 'id', e.target.value)}
                  placeholder="dr-ben-maamar"
                />
              </div>

              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  value={trainer.name || ''}
                  onChange={(e) => handleTrainerUpdate(index, 'name', e.target.value)}
                  placeholder="Dr. Ben Maamar"
                />
              </div>

              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={trainer.title || ''}
                  onChange={(e) => handleTrainerUpdate(index, 'title', e.target.value)}
                  placeholder="Formateur Senior en Implantologie"
                />
              </div>

              <div className="form-group">
                <label>Pays</label>
                <input
                  type="text"
                  value={trainer.country || ''}
                  onChange={(e) => handleTrainerUpdate(index, 'country', e.target.value)}
                  placeholder="Algérie"
                />
              </div>

              <div className="form-group">
                <label>Icône Drapeau</label>
                <input
                  type="text"
                  value={trainer.flagIcon || ''}
                  onChange={(e) => handleTrainerUpdate(index, 'flagIcon', e.target.value)}
                  placeholder="🇩🇿"
                />
              </div>

              <div className="form-group">
                <label>Photo</label>
                <input
                  type="text"
                  value={trainer.photo || ''}
                  onChange={(e) => handleTrainerUpdate(index, 'photo', e.target.value)}
                  placeholder="URL de la photo"
                />
              </div>

              <div className="form-group full-width">
                <label>CV / Biographie</label>
                <textarea
                  value={trainer.cv || ''}
                  onChange={(e) => handleTrainerUpdate(index, 'cv', e.target.value)}
                  placeholder="Biographie et expérience du formateur..."
                  rows={3}
                />
              </div>

              {/* Specialties Section */}
              <div className="form-group full-width">
                <div className="features-section">
                  <div className="features-header">
                    <label>Spécialités</label>
                    <button
                      type="button"
                      className="btn-add-feature"
                      onClick={() => handleAddSpecialty(index)}
                    >
                      <i className="fas fa-plus"></i>
                      Ajouter
                    </button>
                  </div>
                  
                  <div className="features-list">
                    {(trainer.specialties || []).map((specialty, specialtyIndex) => (
                      <div key={specialtyIndex} className="feature-item">
                        <input
                          type="text"
                          value={specialty}
                          onChange={(e) => handleSpecialtyUpdate(index, specialtyIndex, e.target.value)}
                          placeholder="Spécialité..."
                        />
                        <button
                          type="button"
                          className="btn-delete-feature"
                          onClick={() => handleDeleteSpecialty(index, specialtyIndex)}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Formations Section */}
              <div className="form-group full-width">
                <div className="features-section">
                  <div className="features-header">
                    <label>Formations Animées</label>
                    <button
                      type="button"
                      className="btn-add-feature"
                      onClick={() => handleAddFormation(index)}
                    >
                      <i className="fas fa-plus"></i>
                      Ajouter
                    </button>
                  </div>
                  
                  <div className="features-list">
                    {(trainer.formations || []).map((formation, formationIndex) => (
                      <div key={formationIndex} className="feature-item">
                        <input
                          type="text"
                          value={formation}
                          onChange={(e) => handleFormationUpdate(index, formationIndex, e.target.value)}
                          placeholder="Formation..."
                        />
                        <button
                          type="button"
                          className="btn-delete-feature"
                          onClick={() => handleDeleteFormation(index, formationIndex)}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {(!sectionData.trainers || sectionData.trainers.length === 0) && (
        <div className="empty-state">
          <div className="empty-icon">
            <i className="fas fa-user-md"></i>
          </div>
          <h3>Aucun formateur expert</h3>
          <p>Commencez par ajouter votre premier formateur expert.</p>
          <button className="btn-add-first" onClick={handleAddTrainer}>
            <i className="fas fa-plus"></i>
            Ajouter le premier formateur
          </button>
        </div>
      )}
    </div>
  );
};

export default ExpertsTeamAdmin;
